import styled, { css, keyframes } from "styled-components";
interface CustomToastStyleProps {
  type: "success" | "error";
}

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateY(20px);
  }
  to {
    opacity: 0;
    transform: translateY(0);
  }
`;

export const CustomToast = styled.div<CustomToastStyleProps>`
  width: calc(100vw - 32px);
  border-radius: 10px;
  font-size: 1.2rem;
  font-weight: 600;
  display: flex;
  gap: 16px;
  align-items: center;
  padding: 10px 16px !important;
  color: ${(props) => props.theme.colors.white100};
  // animation: ${fadeIn} 0.8s ease-out, ${fadeOut} 0.5s ease-in-out 2.2s forwards;
  z-index: 99999;

  ${(props) =>
    props.type === "success"
      ? css`
          background-color: ${(props) => props.theme.colors.black60};
        `
      : css`
          background-color: #ea3518cc;
        `}
  
  // 모바일 가로 모드 대응
  @media (max-height: 500px) and (orientation: landscape) {
    width: 100%;
  }
`;
